import { getFullNameFromUnknown } from './_nameHelpers';

import { TicketDetail, TicketSummary } from '@/services/TicketsService';

export function getTicketPriorityUpdatedByName(
  ticket: TicketSummary | TicketDetail,
  userFallback: (id: number) => string,
) {
  const updatedByName = getFullNameFromUnknown(ticket.priorityUpdatedBy);

  if (updatedByName) {
    return updatedByName;
  }

  if (ticket.priorityUpdatedByUserId) {
    return userFallback(ticket.priorityUpdatedByUserId);
  }

  return undefined;
}
